import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { PRACTITIONER } from "@/data/site";

const NAV = [
  { to: "/", label: "Accueil", end: true },
  { to: "/a-propos", label: "À propos" },
  { to: "/domaines", label: "Domaines" },
  { to: "/methodes", label: "Méthodes" },
  { to: "/blog", label: "Blog" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-[#E2E8F0]"
          : "bg-transparent"
      }`}
    >
      <div className="container-fxv flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="nav-brand"
          className="flex items-center gap-3 group"
          onClick={() => setOpen(false)}
        >
          <span className="inline-block w-8 h-8 border border-[#C5A059] flex items-center justify-center">
            <span className="font-serif text-[#0C2340] text-lg leading-none">F</span>
          </span>
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-[#0C2340] text-lg">
              {PRACTITIONER.name}
            </span>
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#C5A059]">
              Psychologue · Psychothérapeute
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive
                    ? "text-[#0C2340]"
                    : "text-[#4A5568] hover:text-[#0C2340]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${PRACTITIONER.phone}`}
            data-testid="nav-call-btn"
            className="text-sm text-[#0C2340] flex items-center gap-2 hover:text-[#C5A059] transition-colors"
          >
            <Phone size={16} strokeWidth={1.5} />
            {PRACTITIONER.phoneDisplay}
          </a>
          <Link
            to="/contact"
            data-testid="nav-cta-btn"
            className="rounded-full bg-[#0C2340] text-white px-6 py-3 text-sm font-medium hover:bg-[#163861] transition-colors"
          >
            Prendre rendez-vous
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 text-[#0C2340]"
          aria-label="Menu"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="lg:hidden bg-white border-t border-[#E2E8F0]"
        >
          <div className="container-fxv py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-base ${
                    isActive ? "text-[#0C2340]" : "text-[#4A5568]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="rounded-full bg-[#0C2340] text-white px-6 py-3 text-sm font-medium text-center mt-4"
            >
              Prendre rendez-vous
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
